/**
 * CSR (control) entry for the artwork tag detail route. Mounted under
 * the global `<RootRuntime>` `<ApolloClientProvider>` /
 * `<QueryClientProvider>` via `dynamicWithExperiment` in
 * `routes/_app.tags.artwork.$tag.tsx`.
 *
 * `TagPage` already supports the no-`initial*` path: `useGetTack` /
 * `useTagPageState` / `BaseArtworkInfiniteScroll` will fetch their
 * own data via the global Apollo client. Loader-side seeds and the
 * SSR shell fallback are intentionally ignored here — equivalent to
 * Stage 1 behaviour.
 */
import { useParams } from 'react-router'
import { TagPage } from 'src/pages/AppPage/TagPage'

export default function ArtworkTagPageCsrEntry() {
  const params = useParams<{ tag?: string }>()
  return <TagPage type="artwork" initialTagSlug={params.tag} />
}
